import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CommonDataService } from '../../services/common-data.service';

@Component({
  selector: 'app-glossary-term-usage',
  templateUrl: './glossary-term-usage.component.html'
})
export class GlossaryTermUsageComponent implements OnInit {

  @Output() myEvent = new EventEmitter<string>();
  @Input() GlossaryTermData: any = [];
  termData: any = [];
  termTitle: string = "";
  termUsageTitle: string = "";
  termUsageDef: string = "";

  constructor(private commonDataService: CommonDataService, private route: Router) {

  }
  publicationId: string = "";
  ngOnInit(): void {
    this.publicationId = localStorage.getItem("publicationId");
    this.termTitle = this.GlossaryTermData.name.replace(/(<([^>]+)>)/gi, "");
    let globalLabels = this.commonDataService.globalLabels.getValue();
    if (globalLabels != null) {
      this.termUsageTitle = globalLabels?.content?.data?.labels?.find(x => x.key == 'glossary_termUsage')?.value;
      this.termUsageDef = globalLabels?.content?.data?.labels?.find(x => x.key == 'glossarytermUsage_def')?.value;
    }
    this.GlossaryTermData.topic.forEach(data => {
      let obj = {
        paraNum: Number(data.topic + data.subtopic + data.section),
        termBody: data,
        isGlossary: data.topic == null && data.subtopic == null && data.section == null ? true : false
      }
      this.termData.push(obj);
    });

    let alphabet = " '-—_()0123456789abcdefghijklmnopqrstuvwxyz";
    this.termData.sort((a, b) => {
      if ((!a.isGlossary) && (!b.isGlossary)) {
        if (a.termBody.topic == b.termBody.topic) {
          if (a.termBody.subtopic == b.termBody.subtopic) {
            if (a.termBody.section == b.termBody.section) {
              return a.termBody.paragraph?.split("-")[1] - b.termBody.paragraph?.split("-")[1];
            }
            else {
              return a.termBody.section - b.termBody.section;
            }
          }
          else {
            return a.termBody.subtopic - b.termBody.subtopic;
          }
        }
        else {
          return a.termBody.topic - b.termBody.topic;
        }
      }
      else if (a.isGlossary && (!b.isGlossary)) { return 1; }
      else if ((!a.isGlossary) && b.isGlossary) { return -1; }
      else {
        let pos1 = 0;
        let pos2 = 0;
        for (var i = 0; i < Math.min(a.termBody.paragraphTitle.length, b.termBody.paragraphTitle.length) && pos1 == pos2; i++) {
          pos1 = alphabet.indexOf(a.termBody.paragraphTitle[i].toLowerCase());
          pos2 = alphabet.indexOf(b.termBody.paragraphTitle[i].toLowerCase());
        }

        if (pos1 == pos2 && a.termBody.paragraphTitle.length != b.termBody.paragraphTitle.length) {
          return a.termBody.paragraphTitle.length - b.termBody.paragraphTitle.length;
        }

        return pos1 - pos2;
      }
    });

  }


  mouseOverFunctions(event: any, term) {
    if (event.srcElement.tagName.toLowerCase() == "a" && event.srcElement.className.toLowerCase().includes("glossaryusage")) {
      let url = this.publicationId + "/" + term.termBody.topicId + "/" + term.termBody.topic + "-" + term.termBody.subtopic + "-" + term.termBody.paragraph;
      event.srcElement.setAttribute("href", "/" + url);
    }
  }

  navigateToContent(event, topicIdParam, topicLink) {
    event.preventDefault();
    let topicId = topicIdParam;
    let paranum = topicLink.topic + "-" + topicLink.subtopic + "-" + topicLink.paragraph;
    let url = this.publicationId + "/" + topicId + "/" + paranum;
    this.commonDataService.glossaryTermFromContentPageBackButton.next(this.GlossaryTermData.name);
    this.route.navigateByUrl(url);
    // this.route.navigateByUrl("1141285/1114044/919242/Overview and Background");
    this.commonDataService.NavigatingFromComponent.next("");
    this.commonDataService.childComponent.next(false);
    this.myEvent.emit();
  }

  ngOnDestroy(): void {
    this.commonDataService.glossaryTermData.next([]);
  }


  gotoGlossary(term) {
    if (!this.route.url.includes("MasterGlossary")) {
      this.route.navigateByUrl("/MasterGlossary");
    }
    sessionStorage.setItem("glossaryUsageGlossaryFilter", term);
    this.myEvent.emit();
  }

}
